// Don't store the settings in an object used like ...settings, as it causes a weird bug where the token doesn't get sent.
export async function fetchGet(url) {
    // console.log(`fetch GET: ${url}`);
    try {
        let result = await (
            await fetch(url, {
                method: "GET",
                withCredentials: true,
                credentials: "include",
                headers: {
                    Authorization: localStorage.getItem("token"),
                    Accept: "application/json",
                    "Content-type": "application/json",
                },
            })
        ).json();

        return result;
    } catch (err) {
        return err;
    }
}

export async function fetchPost(url, data) {
    // console.log(`fetch POST: ${url}`);
    try {
        let result = await (
            await fetch(url, {
                method: "POST",
                withCredentials: true,
                credentials: "include",
                headers: {
                    Authorization: localStorage.getItem("token"),
                    Accept: "application/json",
                    "Content-type": "application/json",
                },
                body: JSON.stringify(data),
            })
        ).json();

        return result;
    } catch (err) {
        return err;
    }
}

export async function fetchPatch(url, data) {
    // console.log(`fetch PATCH: ${url}`);
    try {
        let result = await (
            await fetch(url, {
                method: "PATCH",
                withCredentials: true,
                credentials: "include",
                headers: {
                    Authorization: localStorage.getItem("token"),
                    Accept: "application/json",
                    "Content-type": "application/json",
                },
                body: JSON.stringify(data),
            })
        ).json();

        return result;
    } catch (err) {
        return err;
    }
}

export async function fetchDelete(url) {
    // console.log(`fetch DELETE: ${url}`);
    try {
        let result = await (
            await fetch(url, {
                method: "DELETE",
                withCredentials: true,
                credentials: "include",
                headers: {
                    Authorization: localStorage.getItem("token"),
                    Accept: "application/json",
                    "Content-type": "application/json",
                },
            })
        ).json();

        return result;
    } catch (err) {
        return err;
    }
}

export async function fetchGetFile(url, formData) {
    // console.log(`fetch GET FILE: ${url}`);
    try {
        let result = await fetch(url, {
            method: "GET",
            withCredentials: true,
            credentials: "include",
            headers: {
                Authorization: localStorage.getItem("token"),
            },
        });

        return result;
    } catch (err) {
        return err;
    }
}

export async function fetchPostFile(url, formData) {
    // console.log(`fetch POST FILE: ${url}`);
    try {
        let result = await (
            await fetch(url, {
                method: "POST",
                withCredentials: true,
                credentials: "include",
                headers: {
                    Authorization: localStorage.getItem("token"),
                    // Accept: "application/json",
                    // "Content-type": "multipart/form-data",
                },
                body: formData,
            })
        ).json();

        return result;
    } catch (err) {
        return err;
    }
}
